import React, { useEffect, useContext } from 'react';

import { EventMarketingInterface } from 'shared/interfaces/marketing/event-marketing.interface';
import { TrackManagementProps } from 'shared/interfaces/marketing/event-marketing-props.interface';
import {GoogleAdsContext} from "../../../context/tracking/declarations";

let conversionAdsId: string;

const GoogleAdsManagement: React.FC<TrackManagementProps> = ({ data, eventId }) => {
	const { state, setState } = useContext(GoogleAdsContext);

	useEffect(() => () => {
		//@ts-ignore
		window[`ga-disable-${conversionAdsId}`] = true;
	}, [])

	useEffect(() => {
		if (!data) return;
		const index = data.findIndex((el: any) => el.type === 'GOOGLE_ADS');

		if (index !== -1) {
			setGoogleAdsValues(data[index], eventId as string);
			const conversionId = data[index].options?.conversionId;
			if (data[index].status === 'ENABLED' && conversionId) {
				conversionAdsId = conversionId;
				initGoogleAds();
			}
		}
	}, [data]);

	useEffect(() => {
		if (state.active && state.conversionId && state.name === eventId?.toString()) {
			// @ts-ignore
			window[`ga-disable-${state.conversionId}`] = false;
		}
	}, [eventId]);

	const setGoogleAdsValues = (data: EventMarketingInterface, name: string) => {
		setState({
			active: (data.status === 'ENABLED'),
			conversionId: data.options.conversionId ?? '',
			conversionLabel: data.options?.conversionLabel ?? '',
			name: name,
		})
	}

	const initGoogleAds = () => {
		window.gtag('config', `AW-${conversionAdsId}`);
	}

	return (<></>);
}

export default GoogleAdsManagement;
